import React from "react";
import Link from "gatsby-link";
// import ClassNames from 'classnames'

class Benefits extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const data = this.props.data;

    return (
      <div className="Benefits">
        <h2>{this.props.title}</h2>
        <p>{this.props.subtitle}</p>
        <div className="items">
          {data.map((benefit, i) => {
            return (
              <div className="benefit" key={i}>
                <div className="image">
                  <img src={benefit.image.url} alt={benefit.text} />
                </div>
                <h3>{benefit.text}</h3>
                <p>{benefit.subtext}</p>
              </div>
            );
          })}
        </div>
        <h3 className="outro">{this.props.outro}</h3>
        <Link to="/buy" className="Btn orange-white">
          {this.props.callToAction}
        </Link>
      </div>
    );
  }
}

export default Benefits;



// WEBPACK FOOTER //
// ./src/home/benefits.js